import { nuwa_post } from './http'

export const getBannerConfig = (data) => {
    return nuwa_post({ path: '/app/optSpace', data })
}
